import React, { useState } from "react";

const AddExistingUser = () => {
  // Dummy existing users
  const users = [
    { id: 1, name: "Hassan Ali", email: "hassan@example.com" },
    { id: 2, name: "Sara Khan", email: "sara@example.com" },
    { id: 3, name: "Ali Raza", email: "ali@example.com" },
  ];

  const [selectedUser, setSelectedUser] = useState("");

  return (
    <div className="mt-6 p-4 bg-white shadow rounded max-w-md mx-auto">
      <h2 className="text-xl font-bold mb-4">Select Existing User</h2>

      {/* User Select */}
      <select
        value={selectedUser}
        onChange={(e) => setSelectedUser(e.target.value)}
        className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option value="">-- Select User --</option>
        {users.map((user) => (
          <option key={user.id} value={user.id}>
            {user.name} ({user.email})
          </option>
        ))}
      </select>

      {/* Show button only if a user is selected */}
      {selectedUser && (
        <button
          className="mt-4 w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 transition"
        >
          Link Existing User
        </button>
      )}
    </div>
  );
};

export default AddExistingUser;
